import { Box } from "@mui/material";
import React from "react";

import StatCard from "./StatCard";

const SummaryCards: React.FC = () => {
  // Admin dashboard data based on Figma design
  const adminStatsData = [
    {
      title: "Total Income",
      value: "$12,345.67",
      change: -12.15,
      changeText: "Since last week",
      actionText: "View Income",
    },
    {
      title: "Total Patients",
      value: "425",
      change: 25.56,
      changeText: "Since last week",
      actionText: "View Patient",
    },
    {
      title: "Total Appointments",
      value: "$12,345.67",
      change: -12.15,
      changeText: "Since last week",
      actionText: "View Appointment",
    },
    {
      title: "Total Treatment",
      value: "93",
      change: 65.14,
      changeText: "Since last week",
      actionText: "View Staff",
    },
  ];

  return (
    <Box className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {adminStatsData.map((stat) => (
        <StatCard
          key={stat.title}
          title={stat.title}
          value={stat.value}
          change={stat.change}
          changeText={stat.changeText}
          actionText={stat.actionText}
          onActionClick={() => console.log(`${stat.title} clicked`)}
        />
      ))}
    </Box>
  );
};

export default SummaryCards;
